var $405f8b24f5dd2a60$exports = {};
$405f8b24f5dd2a60$exports = {
    "Empty": `T\xfchjenda`
};


export {$405f8b24f5dd2a60$exports as default};
//# sourceMappingURL=et-EE.mjs.map
